export const projectsData = [
    {
        image: '/orfeu.png',
        title: 'Café Orfeu',
        tech: 'React, Typescript e VTEX',
        tasks: ['Homepage;', 'Fluxo de cadastro e acesso do usuário b2b;', 'Landing page e demais funcionalidades relacionadas ao Clube de Assinaturas;', 'Algumas das páginas institucionais;', 'Correções de bugs gerais do projeto.'],
        url: 'https://www.cafeorfeu.com.br/'
    },
    {
        image: '/bazar-horizonte.png',
        title: 'Bazar Horizonte',
        tech: 'React, Typescript e VTEX',
        tasks: ['Homepage;', 'Header;', 'Menu mobile;', 'Página de produto;', 'Página de produto: Seletor de SKU customizado, que exibe uma ampla variedade de SKUs que podem ser adicionados ao carrinho simultaneamente, assim como o modal de imagens que é aberto ao clicar em alguma das variações;', 'Correções de bugs;', 'Ajustes de outras funcionalidades customizadas.'],
        url: 'https://www.bazarhorizonte.com.br/'
    },
    {
        image: '/mizuno.png',
        title: 'Mizuno',
        tech: 'React, Typescript e VTEX',
        tasks: ['Página de Produto: Infobanner dinâmico com as informações sobre linha, peso e tecnologia do produto;', 'Página de Produto: Melhoria do modal das imagens principais, inserindo a navegação por setas e o fechamento do modal;', 'Revisão detalhista da página de produto;', 'Ajustes visuais gerais e de responsividade;', 'Correções de bugs.'],
        url: 'https://www.mizuno.com.br/'
    }
]